(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aryveda-botanical-landing"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('abl-landing')) {
    class AblLanding extends HTMLElement {
      constructor() {
        super();

        this.links = Array.from(this.querySelectorAll('.abl-sidenav__link'));
        this.entries = this.links
          .map((link) => {
            const target = document.getElementById(link.dataset.ablTarget);
            return target ? { link, target } : null;
          })
          .filter(Boolean);

        this.links.forEach((link) => {
          link.addEventListener('click', this.onLinkClick.bind(this));
        });

        if (this.entries.length === 0) return;

        this.observer = new IntersectionObserver(this.onIntersection.bind(this), {
          rootMargin: '-40% 0px -40% 0px',
          threshold: 0,
        });

        this.entries.forEach(({ target }) => this.observer.observe(target));
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      onIntersection(observedEntries) {
        observedEntries.forEach((observedEntry) => {
          const match = this.entries.find(({ target }) => target === observedEntry.target);
          if (!match) return;
          match.link.classList.toggle('is-active', observedEntry.isIntersecting);
        });
      }

      onLinkClick(event) {
        const link = event.currentTarget;
        const target = document.getElementById(link.dataset.ablTarget);
        if (!target) return;

        event.preventDefault();

        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({
          behavior: prefersReducedMotion ? 'auto' : 'smooth',
          block: 'start',
        });
      }
    }

    customElements.define('abl-landing', AblLanding);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ashwagandha-landing"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('al-landing')) {
    class AlLanding extends HTMLElement {
      constructor() {
        super();

        this.links = Array.from(this.querySelectorAll('.al-sidenav__link'));
        this.entries = this.links
          .map((link) => {
            const target = document.getElementById(link.dataset.alTarget);
            return target ? { link, target } : null;
          })
          .filter(Boolean);

        this.links.forEach((link) => {
          link.addEventListener('click', this.onLinkClick.bind(this));
        });

        if (this.entries.length === 0) return;

        this.observer = new IntersectionObserver(this.onIntersection.bind(this), {
          rootMargin: '-40% 0px -40% 0px',
          threshold: 0,
        });

        this.entries.forEach(({ target }) => this.observer.observe(target));
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      onIntersection(observedEntries) {
        observedEntries.forEach((observedEntry) => {
          const match = this.entries.find(({ target }) => target === observedEntry.target);
          if (!match) return;
          match.link.classList.toggle('is-active', observedEntry.isIntersecting);
        });
      }

      onLinkClick(event) {
        const link = event.currentTarget;
        const target = document.getElementById(link.dataset.alTarget);
        if (!target) return;

        event.preventDefault();

        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({
          behavior: prefersReducedMotion ? 'auto' : 'smooth',
          block: 'start',
        });
      }
    }

    customElements.define('al-landing', AlLanding);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
